import React, { FC } from "react";
import { ResultsTableRowData } from "../pages/types";
import SettingsTable from "./table/table";

type Props = {
  headers: string[]
  rows: ResultsTableRowData[] | null;
  sortColumn: number | null;
  titlePlural: string;
};

const SettingsList: FC<Props> = ({ headers, rows, sortColumn = 0, titlePlural }) => {
  
  const sortedRows = rows && sortColumn !== null ? [...rows].sort((a: ResultsTableRowData, b: ResultsTableRowData): number => {
    return a.data[sortColumn].localeCompare(b.data[sortColumn]);
  }) : rows;
  return (
    <>
      <SettingsTable ariaLabel={`${titlePlural} List`} headers={headers} rows={sortedRows} />
    </>
  );
};
export default SettingsList;
